import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TestReportingDataService } from '../../data-services/testReporting.service';
import { PTauUploadResultsDTO } from '../../models/ptau-upload-results-dto';
import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { ngfModule } from "angular-file";

@Component({
  selector: 'app-upload-intervenn-results',
  templateUrl: './uploadInterVennResults.html',
  providers: [MessageService],
  imports: [ButtonModule, Toast, CommonModule, ngfModule]
})
export class UploadInterVennResultsComponent implements OnInit {

  constructor(
    private messageService: MessageService,
    private testReportingService: TestReportingDataService) {
  }

  loading: boolean;
  showSpinner: boolean = false;
  files: File[] = [];

  fileUploading: boolean = false;
  uploadFormData: FormData;
  acceptTypes: string = "text/csv";
  uploadResults: PTauUploadResultsDTO = null;
  fileName: string;

  ngOnInit() {

  }

  public uploadFilesChanged() {
    if (this.files.length != 1) {
      console.log('Unexpected file count found - ' + this.files.length.toString());
      return;
    }

    var fileName = this.files[0].name;
    var reader = new FileReader();
    reader.readAsBinaryString(this.files[0]);
    reader.onload = (event) => {
      var fileContent = btoa(event.target.result.toString());

      this.testReportingService.uploadInterVennResults(fileName, fileContent).subscribe((data: any) => {
        this.testReportingService.getInterVennUploadResults(fileName).subscribe((response: any) => {
          if (response) {
            this.fileName = fileName;
            this.uploadResults = response;
          }
        }, (err) => {
          this.messageService.add({ sticky: true, severity: 'error', summary: 'Unable to retrieve upload results ', detail: 'Failed: ' + err.error });
        });
        this.messageService.add({ sticky: true, severity: 'success', summary: 'Results file successfully uploaded' });
      }, (err) => {
        console.log(`Error: ` + err.error)
        this.fileUploading = false;
        this.messageService.add({ sticky: true, severity: 'error', summary: 'Error Uploading File ', detail: 'Failed: ' + err.error });
      });

    };

    this.files = [];
  }

  public removeToast() {
    this.messageService.clear();
  }
}
